import React, { useEffect, useState } from "react"
import {
  Form,
  Label,
  Row,
  Col,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  FormFeedback,
} from "reactstrap"
import PANImageUpload from "./panCardImage"
import toast from "react-hot-toast"
import { APICore } from "helpers/api/apiCore"
import { useLogout } from "hooks/useLogout"
import Spinners from "components/Common/Spinner"
import { useFormik } from "formik"
import * as Yup from "yup"
import { allStates } from "helpers/utils"
import Swal from "sweetalert2"
import {
  renderAddressValue,
  sweetAlertClasses,
  urlToFile,
} from "helpers/common"
import radioBtnIcon from "../../../../assets/images/icons/radio-btn-icon.svg"
import radioBtnIconUnchecked from "../../../../assets/images/icons/radio-btn-unchecked.svg"
import gstIcon from "../../../../assets/images/icons/gst-icon.svg"
import addressIcon from "../../../../assets/images/icons/address-icon.svg"
import incorporationIcon from "../../../../assets/images/icons/incorporation-icon.svg"
import CummunicationAddress from "./CummunicationAddress"
import KYCPrevButton from "./kycPrevButton"
import BusinessDetailsModel from "./businessDetailsModel"
import {
  useResolveOnboardedBusinessDetailsManuallyMutation,
  useResolveOnboardedBusinessDetailsMutation,
} from "store/api/wealthpartnerapi/onboardResolve.api"

const api = new APICore()

const PANCard = ({ kycData, currentStep }) => {
  const [file, setFile] = useState(null)
  const [panDetails, setPanDetails] = useState([])
  const [dataType, setDataType] = useState("no_data")
  const [isLoading, setIsLoading] = useState(false)
  const logout = useLogout()
  const [open, setOpen] = useState(false)
  const [mutate, { isLoading: onSaving }] =
    useResolveOnboardedBusinessDetailsMutation()
  const [manuallySave, { isLoading: onSavingManually }] =
    useResolveOnboardedBusinessDetailsManuallyMutation()
  const [alertModal, setAlertModal] = useState(false)
  const [selectedBusiness, setSelectedBusiness] = useState({})
  const [openAddress, setOpenAddress] = useState(false)

  const saveBusinessDetails = async (params) => {
    try {
      const { data, success, message } = await mutate({
        ...params,
        id: kycData.id,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "successMessage" })
        proceedToNext()
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }

      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  useEffect(() => {
    if (kycData && currentStep === "GST_DETAILS") {
      setDataType("single")
      setPanDetails([kycData?.investorCompanyDetails])
      if (kycData?.investorCompanyDetails) {
        validation.setValues({
          pan: kycData?.investorCompanyDetails?.pan,
          gstin: kycData?.investorCompanyDetails?.gstin,
          business_address: kycData?.investorCompanyDetails?.business_address,
          date_of_incorporation:
            kycData?.investorCompanyDetails?.date_of_incorporation,
          entity_name: kycData?.investorCompanyDetails?.entity_name,
          constitution_of_business:
            kycData?.investorCompanyDetails?.constitution_of_business,
          is_comm_address_same:
            kycData?.investorCompanyDetails?.is_comm_address_same || "SAME",
          communication_address:
            kycData?.investorCompanyDetails?.communication_address,
        })
      }
    }
    if (kycData && currentStep === "GST_WAIVER") {
      setDataType("failed")
    }
    if (kycData?.investorCompanyDetails?.pan_image) {
      convertUrlToFile(
        kycData?.investorCompanyDetails?.pan_image,
        kycData?.investorCompanyDetails?.pan_image_url
      )
    }
  }, [kycData, currentStep])

  const convertUrlToFile = async (name, file) => {
    try {
      const fileObject = await urlToFile(file, name)
      setFile(fileObject)
    } catch (error) {}
  }
  console.log()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      pan: "",
      gstin: "",
      entity_name: "",
      constitution_of_business: "",
      business_address: "",
      is_comm_address_same: "SAME",
      communication_address: "",
      date_of_incorporation: "",
    },
    validationSchema: Yup.object({}),
    onSubmit: async (values, { resetForm }) => {
      saveBusinessDetails(values)
    },
  })

  useEffect(() => {
    if (
      validation.values.is_comm_address_same === "DIFFERENT" &&
      !validation.values.communication_address
    ) {
      setOpenAddress(true)
    }
  }, [validation.values])

  const handleImageUpload = async () => {
    if (!file) {
      toast.error("Please select file.", {
        id: "toasterMessage",
      })
      return
    }
    setIsLoading(true)
    try {
      const { data } = await api.uploadFile(
        `/wealthPartner/onboardResolve/pan_gst_verify/${kycData.id}`,
        {
          file,
        }
      )
      if (data.success) {
        const { companyDetails, type, pan, name } = data?.data
        if (type === "single") {
          setPanDetails(companyDetails)
          setDataType(type)
          validation.setValues({
            pan,
            gstin: companyDetails[0]["gstin"],
            business_address: companyDetails[0]["business_address"],
            date_of_incorporation: companyDetails[0]["date_of_incorporation"],
            is_comm_address_same: "SAME",
            communication_address: "",
            entity_name: companyDetails[0]["entity_name"],
            constitution_of_business:
              companyDetails[0]["constitution_of_business"],
          })
        }
        if (type === "multiple") {
          setPanDetails(companyDetails)
          setOpen(true)
          validation.setValues({
            pan,
            gstin: companyDetails[0]["gstin"],
            business_address: companyDetails[0]["business_address"],
            date_of_incorporation: companyDetails[0]["date_of_incorporation"],
            entity_name: companyDetails[0]["entity_name"],
            is_comm_address_same: "SAME",
            communication_address: "",
            constitution_of_business:
              companyDetails[0]["constitution_of_business"],
          })
        }
        if (type === "failed") {
          setAlertModal(true)
          manualValidation.setValues({
            entity_name: name,
            pan,
            is_comm_address_same: "SAME",
            communication_address: "",
            date_of_incorporation: data?.data?.date_of_incorporation,
          })
        }
      }
    } catch (error) {
      if (error.status === 401) {
        logout()
      }
      if (error.status === 406) {
        Swal.fire({
          title: "Error!",
          html: `<p>The PAN document you have uploaded does not match the PAN associated with your registration link.</p>

              <p>Please ensure that you upload the correct PAN linked to your registration.</p>

              <p>You may choose to:</p>
              <ul style="list-style: none;">
                <li>Re-upload PAN, OR</li>
                <li>Contact Support for assistance</li>
              </ul>`,
          icon: "error",
          confirmButtonColor: "#BD0000",
          confirmButtonText: "Try again",
          customClass: { ...sweetAlertClasses },
        })

        return
      }
      toast.error(error?.response?.data?.message, { id: "toasterMessage" })
    } finally {
      setIsLoading(false)
    }
  }

  const proceedToNext = async () => {
    window.location.reload()
  }

  const onSaveManually = async (params) => {
    try {
      const { success, message } = await manuallySave({
        ...params,
        id: kycData.id,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "successMessage" })
        proceedToNext()
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        manualValidation.setErrors(errors)
      }

      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const manualValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      pan: kycData?.investorCompanyDetails?.pan,
      entity_name: kycData?.investorCompanyDetails?.entity_name,
      constitution_of_business:
        kycData?.investorCompanyDetails?.constitution_of_business,
      address_one: kycData?.investorCompanyDetails?.address_one,
      address_two: kycData?.investorCompanyDetails?.address_two,
      address_three: kycData?.investorCompanyDetails?.address_three,
      city: kycData?.investorCompanyDetails?.city,
      state: kycData?.investorCompanyDetails?.state,
      pin_code: kycData?.investorCompanyDetails?.pin_code,
      is_comm_address_same:
        kycData?.investorCompanyDetails?.is_comm_address_same || "SAME",
      communication_address:
        kycData?.investorCompanyDetails?.communication_address,
      date_of_incorporation:
        kycData?.investorCompanyDetails?.date_of_incorporation,
    },
    validationSchema: Yup.object({}),
    onSubmit: async (values) => {
      onSaveManually(values)
    },
  })

  useEffect(() => {
    if (
      manualValidation.values.is_comm_address_same === "DIFFERENT" &&
      !manualValidation.values.communication_address
    ) {
      setOpenAddress(true)
    }
  }, [manualValidation.values])

  const onSelectBusiness = (item) => {
    setSelectedBusiness(item)
    Object.keys(item).forEach((el) => validation.setFieldValue(el, item[el]))
  }

  if (dataType === "no_data")
    return (
      <>
        <div className="bank-details-wrapper">
          <h5 className="title mb-3">Proof of Identity</h5>
          <div>
            <Row className="mb-2">
              <Col xl={12}>
                <Label className="col-form-label">
                  PAN Card <span className="error">*</span>
                </Label>

                <PANImageUpload
                  file={file}
                  setFile={setFile}
                  placeholder="Upload PAN Card Image"
                />
              </Col>

              <Col sm={12}>
                <Row className="mt-4">
                  <Col>
                    <button
                      type="button"
                      className="btn btn-primary w-100"
                      onClick={handleImageUpload}
                      disabled={isLoading}
                    >
                      {isLoading ? <Spinners /> : "Save & Next"}
                    </button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>

        {open && (
          <Modal
            centered
            isOpen={open}
            toggle={() => {
              setOpen((prev) => !prev)
            }}
            size="lg"
          >
            <ModalHeader
              toggle={() => {
                setOpen((prev) => !prev)
              }}
            >
              Select Your Business Information
              <p
                style={{
                  fontSize: "13px",
                  color: "#7a7a7a",
                  fontWeight: "400",
                  margin: "0px",
                }}
              >
                Please choose the entity you want to continue with
              </p>
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={(e) => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                {panDetails.map((item, index) => {
                  const isActive = item.gstin === selectedBusiness.gstin
                  return (
                    <div
                      className={`business-select-box-wrapper ${
                        isActive && "active"
                      }`}
                      key={`business_select_i${index}`}
                      onClick={() => onSelectBusiness(item)}
                    >
                      <div className="business-select-box-inner">
                        <div className="d-flex align-items-center gap-2">
                          <img
                            height={"20px"}
                            src={
                              isActive ? radioBtnIcon : radioBtnIconUnchecked
                            }
                            alt=""
                          />
                          <h3>{item.entity_name}</h3>
                        </div>
                      </div>
                      <div className="business-select-box">
                        <div className="">
                          <div className="d-flex align-items-center gap-2">
                            <img height={"20px"} src={gstIcon} alt="" />
                            <p className="col-form-label">GSTIN</p>
                          </div>
                          <h4>{item.gstin}</h4>
                        </div>
                        <div className="">
                          <div className="d-flex align-items-center gap-2">
                            <img height={"20px"} src={addressIcon} alt="" />
                            <p className="col-form-label">Address</p>
                          </div>
                          <h4>{item.business_address}</h4>
                        </div>
                        <div className="">
                          <div className="d-flex align-items-center gap-2">
                            <img
                              height={"20px"}
                              src={incorporationIcon}
                              alt=""
                            />
                            <p className="col-form-label">Incorporation</p>
                          </div>
                          <h4>{item.date_of_incorporation}</h4>
                        </div>
                      </div>
                    </div>
                  )
                })}
                <div className="d-flex justify-content-end align-items-center gap-2">
                  <Button
                    className="confirm-and-continue-btn"
                    type="submit"
                    color="primary"
                    disabled={onSaving}
                  >
                    {onSaving ? <Spinners /> : "Save & Next"}
                  </Button>
                </div>
              </Form>
            </ModalBody>
          </Modal>
        )}

        {alertModal && (
          <BusinessDetailsModel
            open={alertModal}
            setOpen={setAlertModal}
            kycData={kycData}
          />
        )}
      </>
    )

  if (dataType === "single") {
    const data = panDetails[0]
    return (
      <>
        <div className="bank-details-wrapper">
          <h5 className="title mb-3">Your Business Information</h5>
          <p style={{ fontSize: "14px" }}>
            Details fetched from your uploaded PAN
          </p>
          <div>
            <Form
              onSubmit={(e) => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <Row className="mb-2">
                <Col xl={12}>
                  <Label className="col-form-label">
                    PAN <span className="error">*</span>
                  </Label>
                  <Input
                    disabled
                    name="pan"
                    type="text"
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="PAN"
                    value={validation.values.pan}
                  />
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">
                    GSTIN <span className="error">*</span>
                  </Label>
                  <Input
                    name="gstin"
                    type="text"
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="GSTIN"
                    value={validation.values.gstin}
                    onChange={validation.handleChange}
                  />
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">
                    Name of the Entity<span className="error">*</span>
                  </Label>
                  <Input
                    name="entity_name"
                    type="text"
                    disabled
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="Entity Name"
                    value={validation.values.entity_name}
                  />
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">
                    Registered Address
                    <span className="error">*</span>
                  </Label>
                  <textarea
                    name="business_address"
                    type="text"
                    className="form-control"
                    value={validation.values.business_address}
                    onChange={validation.handleChange}
                  />
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">
                    Is Communication Address same as Registered Address?
                    <span className="error">*</span>
                  </Label>
                  <div className="d-flex flex-row gap-2 cp">
                    <Input
                      className="cp"
                      name="is_comm_address_same"
                      type="radio"
                      value={"SAME"}
                      checked={
                        validation.values.is_comm_address_same === "SAME"
                      }
                      onChange={validation.handleChange}
                      id="comm_address_same"
                    />
                    <Label for="comm_address_same">Yes</Label>
                  </div>
                  <div className="d-flex flex-row gap-2 cp">
                    <Input
                      className="cp"
                      name="is_comm_address_same"
                      type="radio"
                      value={"DIFFERENT"}
                      checked={
                        validation.values.is_comm_address_same === "DIFFERENT"
                      }
                      onChange={validation.handleChange}
                      id="comm_address_different"
                    />
                    <Label for="comm_address_different">No</Label>
                  </div>
                </Col>
                {validation.values.is_comm_address_same === "DIFFERENT" &&
                  validation.values.communication_address && (
                    <Col xl={12}>
                      <p
                        className="cp"
                        style={{
                          color: "#09518c",
                          textAlign: "right",
                          fontSize: "13px",
                        }}
                        onClick={() => setOpenAddress(true)}
                      >
                        Edit
                      </p>
                      <textarea
                        type="text"
                        rows={"3"}
                        disabled
                        className="form-control"
                        value={renderAddressValue(
                          validation.values.communication_address
                        )}
                      />
                    </Col>
                  )}

                <Col xl={12}>
                  <Label className="col-form-label">
                    Date of Incorporation
                    <span className="error">*</span>
                  </Label>
                  <Input
                    name="date_of_incorporation"
                    disabled
                    type="text"
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="XXXX"
                    value={data.date_of_incorporation}
                  />
                </Col>
                <Col sm={12}>
                  <Row className="mt-4">
                    <KYCPrevButton
                      kycData={kycData}
                      currentStep={currentStep}
                      disabled={onSavingManually}
                      ButtonHtml={
                        <Button
                          className="confirm-and-continue-btn w-100"
                          type="submit"
                          disabled={onSavingManually}
                        >
                          {onSavingManually ? <Spinners /> : "Save & Next"}
                        </Button>
                      }
                    />
                  </Row>
                </Col>
              </Row>
            </Form>

            {validation.values.is_comm_address_same === "DIFFERENT" && (
              <CummunicationAddress
                openAddress={openAddress}
                setOpenAddress={(val, data) => {
                  if (
                    !val &&
                    (!data ||
                      (typeof data === "object" &&
                        Object.keys(data).length === 0))
                  ) {
                    validation.setFieldValue("is_comm_address_same", "SAME")
                  }
                  setOpenAddress(val)
                }}
                data={validation.values.communication_address}
                setData={(data) =>
                  validation.setFieldValue("communication_address", data)
                }
              />
            )}
          </div>
        </div>
      </>
    )
  }

  if (dataType === "failed") {
    return (
      <>
        <Form
          onSubmit={(e) => {
            e.preventDefault()
            manualValidation.handleSubmit()
            return false
          }}
        >
          <div className="bank-details-wrapper">
            <h5 className="title mb-3">Your Business Information</h5>
            <p style={{ fontSize: "14px" }}>
              Details fetched from your uploaded PAN
            </p>
            <div>
              <Row className="mb-2">
                <Col xl={12}>
                  <Label className="col-form-label">
                    PAN <span className="error">*</span>
                  </Label>
                  <Input
                    name="pan"
                    type="text"
                    disabled={manualValidation.values.pan}
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="Enter Your PAN Number"
                    value={manualValidation.values.pan}
                    onChange={manualValidation.handleChange}
                    invalid={
                      manualValidation.touched.pan &&
                      manualValidation.errors.pan
                    }
                  />
                  {manualValidation.touched.pan &&
                  manualValidation.errors.pan ? (
                    <FormFeedback type="invalid">
                      {manualValidation.errors.pan}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">
                    Name of the Entity <span className="error">*</span>
                  </Label>
                  <Input
                    name="entity_name"
                    type="text"
                    disabled={manualValidation.values.entity_name}
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="Enter Entity Name"
                    value={manualValidation.values.entity_name}
                    onChange={manualValidation.handleChange}
                    invalid={
                      manualValidation.touched.entity_name &&
                      manualValidation.errors.entity_name
                    }
                  />
                  {manualValidation.touched.entity_name &&
                  manualValidation.errors.entity_name ? (
                    <FormFeedback type="invalid">
                      {manualValidation.errors.entity_name}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">
                    Registered Address Line 1<span className="error">*</span>
                  </Label>
                  <Input
                    name="address_one"
                    type="text"
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="Registered Address Line 1"
                    value={manualValidation.values.address_one}
                    onChange={manualValidation.handleChange}
                    invalid={manualValidation.errors.address_one}
                  />
                  {manualValidation.errors.address_one ? (
                    <FormFeedback type="invalid">
                      {manualValidation.errors.address_one}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">
                    Registered Address Line 2
                  </Label>
                  <Input
                    name="address_two"
                    type="text"
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="Registered Address Line 2"
                    value={manualValidation.values.address_two}
                    onChange={manualValidation.handleChange}
                    invalid={manualValidation.errors.address_two}
                  />
                  {manualValidation.errors.address_two ? (
                    <FormFeedback type="invalid">
                      {manualValidation.errors.address_two}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">
                    Registered Address Line 3
                  </Label>
                  <Input
                    name="address_three"
                    type="text"
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="Registered Address Line 3"
                    value={manualValidation.values.address_three}
                    onChange={manualValidation.handleChange}
                    invalid={manualValidation.errors.address_three}
                  />
                  {manualValidation.errors.address_three ? (
                    <FormFeedback type="invalid">
                      {manualValidation.errors.address_three}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">
                    City<span className="error">*</span>
                  </Label>
                  <Input
                    name="city"
                    type="text"
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="Enter City"
                    value={manualValidation.values.city}
                    onChange={manualValidation.handleChange}
                    invalid={manualValidation.errors.city}
                  />
                  {manualValidation.errors.city ? (
                    <FormFeedback type="invalid">
                      {manualValidation.errors.city}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col xl={12}>
                  <Label className="col-form-label">
                    State<span className="error">*</span>
                  </Label>

                  <select
                    id="state"
                    name="state"
                    className="form-select"
                    value={manualValidation.values.state}
                    onChange={manualValidation.handleChange}
                  >
                    <option value=""> Select</option>
                    {allStates.map((item, index) => (
                      <option key={`business_type_${index}`} value={item.key}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  {manualValidation.errors.state ? (
                    <FormFeedback type="invalid">
                      {manualValidation.errors.state}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">
                    PIN Code
                    <span className="error">*</span>
                  </Label>
                  <Input
                    name="pin_code"
                    type="text"
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="Enter Pin Code"
                    value={manualValidation.values.pin_code}
                    onChange={manualValidation.handleChange}
                    invalid={manualValidation.errors.pin_code}
                  />
                  {manualValidation.errors.pin_code ? (
                    <FormFeedback type="invalid">
                      {manualValidation.errors.pin_code}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col xl={12}>
                  <Label className="col-form-label">
                    Is Communication Address same as Registered Address?
                    <span className="error">*</span>
                  </Label>
                  <div className="d-flex flex-row gap-2 cp">
                    <Input
                      className="cp"
                      name="is_comm_address_same"
                      type="radio"
                      value={"SAME"}
                      checked={
                        manualValidation.values.is_comm_address_same === "SAME"
                      }
                      onChange={manualValidation.handleChange}
                      id="comm_address_same"
                    />
                    <Label for="comm_address_same">Yes</Label>
                  </div>
                  <div className="d-flex flex-row gap-2 cp">
                    <Input
                      className="cp"
                      name="is_comm_address_same"
                      type="radio"
                      value={"DIFFERENT"}
                      checked={
                        manualValidation.values.is_comm_address_same ===
                        "DIFFERENT"
                      }
                      onChange={manualValidation.handleChange}
                      id="comm_address_different"
                    />
                    <Label for="comm_address_different">No</Label>
                  </div>
                </Col>
                {manualValidation.values.is_comm_address_same === "DIFFERENT" &&
                  manualValidation.values.communication_address && (
                    <Col xl={12}>
                      <p
                        className="cp"
                        style={{
                          color: "#09518c",
                          textAlign: "right",
                          fontSize: "13px",
                        }}
                        onClick={() => setOpenAddress(true)}
                      >
                        Edit
                      </p>
                      <textarea
                        type="text"
                        rows={"3"}
                        disabled
                        className="form-control"
                        value={renderAddressValue(
                          manualValidation.values.communication_address
                        )}
                      />
                    </Col>
                  )}

                <Col xl={12}>
                  <Label className="col-form-label">
                    Date of Incorporation
                    <span className="error">*</span>
                  </Label>
                  <Input
                    name="date_of_incorporation"
                    type="text"
                    disabled={manualValidation.values.date_of_incorporation}
                    className="form-control"
                    id="horizontal-firstname-Input"
                    value={manualValidation.values.date_of_incorporation}
                    onChange={manualValidation.handleChange}
                    invalid={
                      manualValidation.touched.date_of_incorporation &&
                      manualValidation.errors.date_of_incorporation
                    }
                  />
                  {manualValidation.touched.date_of_incorporation &&
                  manualValidation.errors.date_of_incorporation ? (
                    <FormFeedback type="invalid">
                      {manualValidation.errors.date_of_incorporation}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col sm={12}>
                  <Row className="mt-4">
                    <KYCPrevButton
                      kycData={kycData}
                      currentStep={currentStep}
                      disabled={onSavingManually}
                      ButtonHtml={
                        <button
                          type="submit"
                          className="btn btn-primary w-100"
                          disabled={onSavingManually}
                        >
                          {onSavingManually ? <Spinners /> : "Save & Next"}
                        </button>
                      }
                    />
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </Form>

        {manualValidation.values.is_comm_address_same === "DIFFERENT" && (
          <CummunicationAddress
            openAddress={openAddress}
            setOpenAddress={(val, data) => {
              if (
                !val &&
                (!data ||
                  (typeof data === "object" && Object.keys(data).length === 0))
              ) {
                manualValidation.setFieldValue("is_comm_address_same", "SAME")
              }
              setOpenAddress(val)
            }}
            data={manualValidation.values.communication_address}
            setData={(data) =>
              manualValidation.setFieldValue("communication_address", data)
            }
          />
        )}
      </>
    )
  }
}

export default PANCard
